import { inject, Injectable } from '@angular/core';
import { SOFTLINE_AI_AGENT_CLIENT_TOOLS } from '../ai-agent.tokens';
import { AgUiTool } from '../types/ag-ui.types';
import { AnyAiAgentClientTool } from '../types/client-tool.type';

/** Resolves client tools by name and renders their wire declarations. */
@Injectable({ providedIn: 'root' })
export class AiAgentClientToolRegistry {
  private readonly tools: AnyAiAgentClientTool[] = (
    inject(SOFTLINE_AI_AGENT_CLIENT_TOOLS, { optional: true }) ?? []
  ).flat();

  private readonly byName = new Map(this.tools.map((t) => [t.name, t]));

  all(): readonly AnyAiAgentClientTool[] {
    return this.tools;
  }

  find(name: string): AnyAiAgentClientTool | null {
    return this.byName.get(name) ?? null;
  }

  names(): ReadonlySet<string> {
    return new Set(this.byName.keys());
  }

  toWire(): AgUiTool[] {
    return this.tools.map((t) => ({
      name: t.name,
      description: t.description,
      parameters: t.parameters,
    }));
  }
}
